export enum CategoryColorsEnum {
  Alle = '#272D40',
  Arzbrief = '#007E82',
  Cave = '#E30042',
  Diagnosen = '#9D52CA',
  Documentation = '#C35200',
  EpaEntry = '#9FCE10',
  Formulare = '#9397A2',
  KostenEpisoden = '#3241B4',
  Leistungen = '#00BFC6',
  Leistungsketten = '#272D40',
  Medikamente = '#9B92F7',
  Psychotherapie = '#9397A2',
  Rechnung = '#272D40',
  Testverfahren = '#9397A2',
  Protokoll = '#C35200',
  Prescriptions = '#6A9417',
}
